/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeploymentProgressResponseStbGroupStats,
    ReportForDeploymentProgressResponseStbGroupStatsFromJSON,
    ReportForDeploymentProgressResponseStbGroupStatsFromJSONTyped,
    ReportForDeploymentProgressResponseStbGroupStatsToJSON,
} from './ReportForDeploymentProgressResponseStbGroupStats';

/**
 * 
 * @export
 * @interface ReportForDeploymentProgressResponse
 */
export interface ReportForDeploymentProgressResponse {
    /**
     * 
     * @type {ReportForDeploymentProgressResponseStbGroupStats}
     * @memberof ReportForDeploymentProgressResponse
     */
    stbGroupStats: ReportForDeploymentProgressResponseStbGroupStats;
}

export function ReportForDeploymentProgressResponseFromJSON(json: any): ReportForDeploymentProgressResponse {
    return ReportForDeploymentProgressResponseFromJSONTyped(json, false);
}

export function ReportForDeploymentProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeploymentProgressResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stbGroupStats': ReportForDeploymentProgressResponseStbGroupStatsFromJSON(json['stbGroupStats']),
    };
}

export function ReportForDeploymentProgressResponseToJSON(value?: ReportForDeploymentProgressResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stbGroupStats': ReportForDeploymentProgressResponseStbGroupStatsToJSON(value.stbGroupStats),
    };
}

